// register.js
import * as AmazonCognitoIdentity from 'amazon-cognito-identity-js';
import { signUp as googleTagSignUp } from '../google';

import config from '../config';
import { makeAttrs } from './helpers';

export const async_register = (given_name, email, password) => {
  email = email.toLowerCase();
  const poolData = {
    UserPoolId: config.UserPoolID,
    ClientId: config.ClientId
  };
  const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
  const attrs = {
    given_name: given_name,
    email: email,
    address: ''
  };
  const attributeList = makeAttrs(attrs);
  return new Promise((resolve, reject) => {
    userPool.signUp(email, password, attributeList, null, (err, result) => {
      if (err !== null) return reject(err);
      googleTagSignUp();
      return resolve('Successfully registered');
    });
  });
};



// WEBPACK FOOTER //
// ./src/utils/user/register.js